import * as i0 from '@angular/core';
import { Injectable, Component, Input, EventEmitter, ViewChild, Output, NgModule } from '@angular/core';
import { map, pluck, takeUntil, take, distinctUntilChanged } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { Validators, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Subject, combineLatest } from 'rxjs';
import * as errorUtils from 'error-message-utility';
import { VisaTypeList } from 'app-models';
import { USER_PERMISSIONS } from 'permission-library';
import * as i2 from 'reference-library';
import * as i9 from '@angular/common';
import * as i5 from 'primeng/dropdown';
import * as i6 from 'primeng/api';
import * as i7 from 'primeng/radiobutton';
import * as i8 from 'primeng/checkbox';
import * as i9$1 from 'primeng/inputswitch';
import * as i10 from 'primeng/inputnumber';
import * as i11 from 'primeng/inputtextarea';
import * as i12 from 'primeng/inputtext';
import * as i13 from 'primeng/multiselect';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import * as i1$2 from '@angular/router';
import * as i3 from 'ngx-toastr';
import * as i5$1 from '@ngrx/store';
import * as i7$1 from 'primeng/card';
import * as i10$1 from '@angular/material/icon';
import { PrimengLibraryModule } from 'primeng-library';

class CreateTaskLibraryService {
    constructor(http) {
        this.http = http;
    }
    getPetitionList(visaType) {
        return this.http.get(`/${visaType}/petitionTypes`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
            else {
                return [];
            }
        }));
    }
    createPetition(visaType, payload) {
        return this.http.post(`/${visaType}/PETITION/create`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
    getBeneficiariesByCompanyId(companyId, payload) {
        return this.http.post('/petitioner/dashboard/beneficiaries/company/' + companyId, payload).pipe(pluck('data'), pluck('beneficiaryList'), map((benes) => {
            benes.forEach(item => {
                item.firstname = item.beneficiaryEmployeeFName ? item.beneficiaryEmployeeFName : '',
                    item.lastname = item.beneficiaryEmployeeLName ? item.beneficiaryEmployeeLName : '',
                    item.middlename = item.beneficiaryEmployeeMName ? item.beneficiaryEmployeeMName : '-',
                    item.company = (item.companyName) ? item.companyName : '';
            });
            return benes;
        }));
    }
    getPetitionerClientList(companyId, countryType = '') {
        let apiUrl = `/company/${companyId}/hierarchy`;
        if (countryType !== '') {
            apiUrl = `${apiUrl}?${countryType}=USA`;
        }
        return this.http.get(apiUrl).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    getClientsList(companyId, reqJson) {
        return this.http.post(`/attorney/dashboard/petitioner/company/${companyId}`, reqJson).pipe(map((response) => {
            return response.status === 200 ? response.data : [];
        }));
    }
    getSubTasksType(superTaskType) {
        return this.http.get(`/${superTaskType}/taskTypes`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    getSubTasksTypeListImmigrant(immgCategoryCode, immgClasificationCode) {
        return this.http.get(`/subtask/list/immgCategory/${immgCategoryCode}/immgClasification/${immgClasificationCode}`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    saveVisa(payload, visaType) {
        return this.http.post(`/${visaType}/task/add`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    saveTask(payload, immigrantType, immigrantCode) {
        if (immigrantCode === 'IMMPET') {
            return this.http.post(`/task/immigrantCode/${immigrantCode}/immigrationCategory/${payload.immCategoryCode}/immigrationClasification/${payload.immClassificationCode}`, payload).pipe(map((response) => {
                if (response.status === 200) {
                    return response;
                }
            }));
        }
        else {
            return this.http.post(`/task/petitionType/${payload.petitionType}/visaType/${payload.visaType}/immigrantCode/${immigrantType}?outsideImmagility=${payload.isOutsideImagility === 1}`, payload).pipe(map((response) => {
                if (response.status === 200) {
                    return response;
                }
            }));
        }
    }
    getSuperTask(superTaskId) {
        return this.http.get(`/superTask/${superTaskId}/overview`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
}
CreateTaskLibraryService.ɵfac = function CreateTaskLibraryService_Factory(t) { return new (t || CreateTaskLibraryService)(i0.ɵɵinject(i1.HttpClient)); };
CreateTaskLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: CreateTaskLibraryService, factory: CreateTaskLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateTaskLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class PetitionTaskService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getUsersOfCompany(companyId) {
        return this.httpClient.get('/company/' + companyId + '/employee').pipe(map((response) => response.data));
    }
    getReviewersUser(companyId, permissionName) {
        return this.httpClient.get(`/company/${companyId}/employee?permissionName=${permissionName}`).pipe(map((response) => response.data));
    }
    getAttorneysOfCompany(companyId) {
        const payload = {
            pageNo: 0,
            pagination: 0,
            searchCriteria: '',
            searchText: '',
            sortBy: ''
        };
        return this.httpClient.post('/petitioner/dashboard/attorney/company/' + companyId, payload).pipe(map((response) => response.data));
    }
    getActiveAttorneyCompanyList(petCompanyId) {
        return this.httpClient.get(`/petitioner/${petCompanyId}/attorney/list`).pipe(map((response) => response.data));
    }
    getPetitionerClientList(companyId, countryType = '') {
        let apiUrl = `/company/${companyId}/hierarchy`;
        if (countryType !== '') {
            apiUrl = `${apiUrl}?${countryType}=USA`;
        }
        return this.httpClient.get(apiUrl).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    getForeignCompanyListForEVisa(visaType, companyId) {
        return this.httpClient.get(`/${visaType}/company/${companyId}/list`).pipe(pluck('data'), map((data) => {
            let returnResult = [];
            if (data && data.length > 0) {
                returnResult = data.map(x => {
                    return Object.assign(Object.assign({}, x), { id: x.companyId });
                });
            }
            return returnResult;
        }));
    }
    getEmployeeDetails(companyId, employeeId) {
        return this.httpClient.get(`/company/${companyId}/employee/${employeeId}`).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    getTaskQuestioneryOnCategory(quesCategory) {
        return this.httpClient.get(`/question/category/${quesCategory}`).pipe(map((response) => response.data));
    }
    // premium
    getServiceCenters(isPremium, visaType, petitionType) {
        return this.httpClient.get(`/serviceCenter/${isPremium}/visaType/${visaType}/petitionType/${petitionType}`).pipe(map((response) => response.data));
    }
}
PetitionTaskService.ɵfac = function PetitionTaskService_Factory(t) { return new (t || PetitionTaskService)(i0.ɵɵinject(i1.HttpClient)); };
PetitionTaskService.ɵprov = i0.ɵɵdefineInjectable({ token: PetitionTaskService, factory: PetitionTaskService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PetitionTaskService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function PetitionTaskComponent_div_2_div_1_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.getGlobalErrorMessages("REQUIRED"), " ");
} }
function PetitionTaskComponent_div_2_div_1_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelementStart(1, "p-checkbox", 32);
    i0.ɵɵlistener("onChange", function PetitionTaskComponent_div_2_div_1_div_22_Template_p_checkbox_onChange_1_listener($event) { i0.ɵɵrestoreView(_r18); const item_r15 = ctx.$implicit; const ctx_r17 = i0.ɵɵnextContext(3); return ctx_r17.updateCheckedOptions($event.checked, item_r15.code); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r15 = ctx.$implicit;
    const i_r16 = ctx.index;
    const ctx_r14 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r14.petitionTaskForm.get("extrAblDocEvdCatgCode").value === ctx_r14.extraBLDOCEVDNCATGList[0].code)("formControlName", i_r16)("label", item_r15.description);
} }
function PetitionTaskComponent_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵelementStart(2, "label", 19);
    i0.ɵɵtext(3, "Field of extraordinary ability ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 20);
    i0.ɵɵelementStart(5, "div", 17);
    i0.ɵɵelementStart(6, "div", 6);
    i0.ɵɵelement(7, "p-dropdown", 21);
    i0.ɵɵtemplate(8, PetitionTaskComponent_div_2_div_1_span_8_Template, 2, 1, "span", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 18);
    i0.ɵɵelementStart(10, "label", 22);
    i0.ɵɵtext(11, "Applicable categories of Documentary Evidence");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 23);
    i0.ɵɵelementStart(13, "div", 17);
    i0.ɵɵelementStart(14, "div", 24);
    i0.ɵɵelementStart(15, "p-radioButton", 25);
    i0.ɵɵlistener("click", function PetitionTaskComponent_div_2_div_1_Template_p_radioButton_click_15_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.clickRadioBtn(ctx_r19.extraBLDOCEVDNCATGList[0].code); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 26);
    i0.ɵɵtext(17, "Or");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 17);
    i0.ɵɵelementStart(19, "div", 23);
    i0.ɵɵelementStart(20, "p-radioButton", 27);
    i0.ɵɵlistener("click", function PetitionTaskComponent_div_2_div_1_Template_p_radioButton_click_20_listener() { i0.ɵɵrestoreView(_r20); const ctx_r21 = i0.ɵɵnextContext(2); return ctx_r21.clickRadioBtn(ctx_r21.extraBLDOCEVDNCATGList[1].code); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 28);
    i0.ɵɵtemplate(22, PetitionTaskComponent_div_2_div_1_div_22_Template, 2, 3, "div", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("options", ctx_r11.fieldExtrAbltyCodeList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.petitionTaskForm.get("fieldExtrAbltyCode").touched && (ctx_r11.petitionTaskForm.get("fieldExtrAbltyCode").errors == null ? null : ctx_r11.petitionTaskForm.get("fieldExtrAbltyCode").errors.required));
    i0.ɵɵadvance(7);
    i0.ɵɵpropertyInterpolate("label", ctx_r11.extraBLDOCEVDNCATGList[0].desc);
    i0.ɵɵproperty("value", ctx_r11.extraBLDOCEVDNCATGList[0].code);
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("label", ctx_r11.extraBLDOCEVDNCATGList[1].desc);
    i0.ɵɵproperty("value", ctx_r11.extraBLDOCEVDNCATGList[1].code);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r11.majorInternationAwardList);
} }
function PetitionTaskComponent_div_2_div_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵelementStart(1, "p-inputSwitch", 39);
    i0.ɵɵlistener("toggleChange", function PetitionTaskComponent_div_2_div_2_div_5_Template_p_inputSwitch_toggleChange_1_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(); const i_r23 = ctx_r28.index; const a_r22 = ctx_r28.$implicit; const ctx_r27 = i0.ɵɵnextContext(2); return ctx_r27.onQuestionToggle(i_r23, a_r22.get("answer").value); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function PetitionTaskComponent_div_2_div_2_div_6_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
function PetitionTaskComponent_div_2_div_2_div_6_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 42);
    i0.ɵɵelementStart(1, "label", 7);
    i0.ɵɵtext(2, "How many?");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-inputNumber", 43);
    i0.ɵɵtemplate(4, PetitionTaskComponent_div_2_div_2_div_6_div_1_span_4_Template, 2, 0, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const a_r22 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("min", 1)("max", 99)("maxlength", 2)("useGrouping", false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", a_r22.get("additionalInfo").touched && a_r22.errors && a_r22.errors["additionalInfoIsRequired"]);
} }
function PetitionTaskComponent_div_2_div_2_div_6_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
function PetitionTaskComponent_div_2_div_2_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵelementStart(1, "label", 7);
    i0.ɵɵtext(2, "Explanation");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "textarea", 44);
    i0.ɵɵtemplate(4, PetitionTaskComponent_div_2_div_2_div_6_div_2_span_4_Template, 2, 0, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const a_r22 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", a_r22.get("additionalInfo").touched && a_r22.errors && a_r22.errors["additionalInfoIsRequired"]);
} }
function PetitionTaskComponent_div_2_div_2_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, PetitionTaskComponent_div_2_div_2_div_6_div_1_Template, 5, 5, "div", 40);
    i0.ɵɵtemplate(2, PetitionTaskComponent_div_2_div_2_div_6_div_2_Template, 5, 1, "div", 41);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r23 = i0.ɵɵnextContext().index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r23 === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r23 === 1);
} }
function PetitionTaskComponent_div_2_div_2_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 45);
    i0.ɵɵelement(1, "input", 46);
    i0.ɵɵelementEnd();
} }
function PetitionTaskComponent_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelementStart(1, "div", 34);
    i0.ɵɵelementStart(2, "div", 17);
    i0.ɵɵelementStart(3, "div", 35);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, PetitionTaskComponent_div_2_div_2_div_5_Template, 2, 0, "div", 36);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, PetitionTaskComponent_div_2_div_2_div_6_Template, 3, 2, "div", 15);
    i0.ɵɵtemplate(7, PetitionTaskComponent_div_2_div_2_div_7_Template, 2, 0, "div", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const a_r22 = ctx.$implicit;
    const i_r23 = ctx.index;
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", i_r23);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.questionList[i_r23] == null ? null : ctx_r12.questionList[i_r23].question, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.questionList[i_r23].isBoolean == 1 || ctx_r12.questionList[i_r23].isBoolean);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.fields.showAdditionalAnswerForQuestions && a_r22.get("answer").value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r12.questionList[i_r23].isBoolean || ctx_r12.questionList[i_r23].isBoolean == 0);
} }
function PetitionTaskComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, PetitionTaskComponent_div_2_div_1_Template, 23, 7, "div", 15);
    i0.ɵɵtemplate(2, PetitionTaskComponent_div_2_div_2_Template, 8, 5, "div", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.visaType === "O1A" || ctx_r0.visaType === "O1B");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r0.getFormQuestionsArray());
} }
function PetitionTaskComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 4);
} }
function PetitionTaskComponent_div_4_div_1_small_4_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "There are no associated companies having non-US incorporation country.");
    i0.ɵɵelementEnd();
} }
function PetitionTaskComponent_div_4_div_1_small_4_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1, "There are no associated companies in the treaty countries for the selected visa.");
    i0.ɵɵelementEnd();
} }
const _c0$1 = function () { return ["L1A", "L1B"]; };
const _c1 = function () { return ["E1", "E2", "E2C"]; };
function PetitionTaskComponent_div_4_div_1_small_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 50);
    i0.ɵɵtemplate(1, PetitionTaskComponent_div_4_div_1_small_4_span_1_Template, 2, 0, "span", 1);
    i0.ɵɵtemplate(2, PetitionTaskComponent_div_4_div_1_small_4_span_2_Template, 2, 0, "span", 1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction0(2, _c0$1).includes(ctx_r40.visaType));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i0.ɵɵpureFunction0(3, _c1).includes(ctx_r40.visaType));
} }
function PetitionTaskComponent_div_4_div_1_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r41 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r41.getGlobalErrorMessages("REQUIRED"), " ");
} }
function PetitionTaskComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "label", 7);
    i0.ɵɵtext(2, "Foreign Company");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 48);
    i0.ɵɵlistener("onChange", function PetitionTaskComponent_div_4_div_1_Template_p_dropdown_onChange_3_listener() { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(2); return ctx_r44.onForeignCompanyChange(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, PetitionTaskComponent_div_4_div_1_small_4_Template, 3, 4, "small", 49);
    i0.ɵɵtemplate(5, PetitionTaskComponent_div_4_div_1_span_5_Template, 2, 1, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r37.foreignCompanyList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r37.foreignCompanyList || ctx_r37.foreignCompanyList && ctx_r37.foreignCompanyList.length === 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r37.petitionTaskForm.get("foreignCompanyId").touched && (ctx_r37.petitionTaskForm.get("foreignCompanyId").errors == null ? null : ctx_r37.petitionTaskForm.get("foreignCompanyId").errors.required));
} }
function PetitionTaskComponent_div_4_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r46.getGlobalErrorMessages("REQUIRED"), " ");
} }
function PetitionTaskComponent_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "label", 7);
    i0.ɵɵtext(2, "Relationship of US Company with Company abroad");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 51);
    i0.ɵɵtemplate(4, PetitionTaskComponent_div_4_div_2_span_4_Template, 2, 1, "span", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r38 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r38.companyRelationList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r38.petitionTaskForm.get("companyRelationCode").touched && (ctx_r38.petitionTaskForm.get("companyRelationCode").errors == null ? null : ctx_r38.petitionTaskForm.get("companyRelationCode").errors.required));
} }
function PetitionTaskComponent_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵelementStart(1, "label", 12);
    i0.ɵɵtext(2, "Treaty Country");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 52);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("readonly", true);
} }
function PetitionTaskComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, PetitionTaskComponent_div_4_div_1_Template, 6, 3, "div", 47);
    i0.ɵɵtemplate(2, PetitionTaskComponent_div_4_div_2_Template, 5, 2, "div", 47);
    i0.ɵɵtemplate(3, PetitionTaskComponent_div_4_div_3_Template, 4, 1, "div", 47);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.fields.showForeignCompany);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.fields.showRelationshipOfUSCompanyWithForeignCompany);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.fields.showTreatyCountry);
} }
function PetitionTaskComponent_ng_template_11_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r47.selectedSignatory == null ? null : ctx_r47.selectedSignatory.firstName) + " " + (ctx_r47.selectedSignatory == null ? null : ctx_r47.selectedSignatory.lastName));
} }
function PetitionTaskComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PetitionTaskComponent_ng_template_11_div_0_Template, 3, 1, "div", 1);
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r3.selectedSignatory);
} }
function PetitionTaskComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r48 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((employee_r48 == null ? null : employee_r48.firstName) + " " + (employee_r48 == null ? null : employee_r48.lastName));
} }
function PetitionTaskComponent_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r5.getGlobalErrorMessages("REQUIRED"), " ");
} }
function PetitionTaskComponent_div_19_ng_template_10_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r51.selectedPreparer == null ? null : ctx_r51.selectedPreparer.firstName) + " " + (ctx_r51.selectedPreparer == null ? null : ctx_r51.selectedPreparer.lastName));
} }
function PetitionTaskComponent_div_19_ng_template_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PetitionTaskComponent_div_19_ng_template_10_div_0_Template, 3, 1, "div", 1);
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r49.selectedPreparer);
} }
function PetitionTaskComponent_div_19_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r52 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((employee_r52 == null ? null : employee_r52.firstName) + " " + (employee_r52 == null ? null : employee_r52.lastName));
} }
function PetitionTaskComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 5);
    i0.ɵɵelementStart(2, "div", 6);
    i0.ɵɵelementStart(3, "label", 12);
    i0.ɵɵtext(4, "Lawfirm");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p-dropdown", 53);
    i0.ɵɵlistener("onChange", function PetitionTaskComponent_div_19_Template_p_dropdown_onChange_5_listener() { i0.ɵɵrestoreView(_r54); const ctx_r53 = i0.ɵɵnextContext(); return ctx_r53.attorneySelected(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 6);
    i0.ɵɵelementStart(7, "label", 12);
    i0.ɵɵtext(8, "Authorized Signatory");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "p-dropdown", 54);
    i0.ɵɵlistener("onChange", function PetitionTaskComponent_div_19_Template_p_dropdown_onChange_9_listener() { i0.ɵɵrestoreView(_r54); const ctx_r55 = i0.ɵɵnextContext(); return ctx_r55.userPreparerSelected(); });
    i0.ɵɵtemplate(10, PetitionTaskComponent_div_19_ng_template_10_Template, 1, 1, "ng-template", 9);
    i0.ɵɵtemplate(11, PetitionTaskComponent_div_19_ng_template_11_Template, 3, 1, "ng-template", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("options", ctx_r6.attorneys);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r6.attorneyUsers);
} }
function PetitionTaskComponent_div_20_ng_template_13_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r60 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r60.selectedPreparer == null ? null : ctx_r60.selectedPreparer.firstName) + " " + (ctx_r60.selectedPreparer == null ? null : ctx_r60.selectedPreparer.lastName));
} }
function PetitionTaskComponent_div_20_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PetitionTaskComponent_div_20_ng_template_13_div_0_Template, 3, 1, "div", 1);
} if (rf & 2) {
    const ctx_r56 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r56.selectedPreparer);
} }
function PetitionTaskComponent_div_20_ng_template_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r61 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((employee_r61 == null ? null : employee_r61.firstName) + " " + (employee_r61 == null ? null : employee_r61.lastName));
} }
function PetitionTaskComponent_div_20_ng_template_19_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r62 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r62.selectedLawFirmUsersTextArr.join(", "));
} }
function PetitionTaskComponent_div_20_ng_template_19_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1, "Select");
    i0.ɵɵelementEnd();
} }
function PetitionTaskComponent_div_20_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PetitionTaskComponent_div_20_ng_template_19_div_0_Template, 2, 1, "div", 1);
    i0.ɵɵtemplate(1, PetitionTaskComponent_div_20_ng_template_19_div_1_Template, 2, 0, "div", 1);
} if (rf & 2) {
    const ctx_r58 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", ctx_r58.selectedLawFirmUsers.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r58.selectedLawFirmUsers.length);
} }
function PetitionTaskComponent_div_20_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r64 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((employee_r64 == null ? null : employee_r64.firstName) + " " + (employee_r64 == null ? null : employee_r64.lastName));
} }
function PetitionTaskComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h5", 55);
    i0.ɵɵtext(2, "Lawfirm Details ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 17);
    i0.ɵɵelementStart(4, "div", 56);
    i0.ɵɵelementStart(5, "label", 57);
    i0.ɵɵtext(6, "Firm Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 58);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 6);
    i0.ɵɵelementStart(10, "label", 59);
    i0.ɵɵtext(11, "Authorized Signatory");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "p-dropdown", 60);
    i0.ɵɵlistener("onChange", function PetitionTaskComponent_div_20_Template_p_dropdown_onChange_12_listener() { i0.ɵɵrestoreView(_r66); const ctx_r65 = i0.ɵɵnextContext(); return ctx_r65.userPreparerSelected(); });
    i0.ɵɵtemplate(13, PetitionTaskComponent_div_20_ng_template_13_Template, 1, 1, "ng-template", 9);
    i0.ɵɵtemplate(14, PetitionTaskComponent_div_20_ng_template_14_Template, 3, 1, "ng-template", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 6);
    i0.ɵɵelementStart(16, "label", 59);
    i0.ɵɵtext(17, "Law Firm Users");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "p-multiSelect", 61);
    i0.ɵɵlistener("onChange", function PetitionTaskComponent_div_20_Template_p_multiSelect_onChange_18_listener() { i0.ɵɵrestoreView(_r66); const ctx_r67 = i0.ɵɵnextContext(); return ctx_r67.usersLawFrimSelected(); });
    i0.ɵɵtemplate(19, PetitionTaskComponent_div_20_ng_template_19_Template, 2, 2, "ng-template", 62);
    i0.ɵɵtemplate(20, PetitionTaskComponent_div_20_ng_template_20_Template, 2, 1, "ng-template", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.employeeDetails == null ? null : ctx_r7.employeeDetails.companyName, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r7.attorneyUsers);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("options", ctx_r7.lawFirmUsersList);
} }
function PetitionTaskComponent_ng_template_27_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r68 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r68.selectedPetetionPreprarer == null ? null : ctx_r68.selectedPetetionPreprarer.firstName) ? (ctx_r68.selectedPetetionPreprarer == null ? null : ctx_r68.selectedPetetionPreprarer.firstName) + " " + (ctx_r68.selectedPetetionPreprarer == null ? null : ctx_r68.selectedPetetionPreprarer.lastName) : "--");
} }
function PetitionTaskComponent_ng_template_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, PetitionTaskComponent_ng_template_27_div_0_Template, 3, 1, "div", 1);
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r8.selectedPetetionPreprarer);
} }
function PetitionTaskComponent_ng_template_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r69 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((employee_r69 == null ? null : employee_r69.firstName) + " " + (employee_r69 == null ? null : employee_r69.lastName));
} }
function PetitionTaskComponent_span_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.getGlobalErrorMessages("REQUIRED"), " ");
} }
class PetitionTaskComponent {
    constructor(fb, referenceLibraryService, apiService) {
        this.fb = fb;
        this.referenceLibraryService = referenceLibraryService;
        this.apiService = apiService;
        this.serviceCenters = [];
        this.reviewUsersList = [];
        this.attorneys = [];
        this.attorneyUsers = [];
        this.users = [];
        this.isOutsideImagility = true;
        this.petitionUpdates = [false, false];
        this.foreignCompanyList = [];
        this.companyRelationList = [];
        this.fieldExtrAbltyCodeList = [];
        this.extraBLDOCEVDNCATGList = [];
        this.majorInternationAwardList = [];
        this.applicableOptionItem = [{
                code: String,
                name: String,
                description: String
            }];
        this.ngUnsubscribe = new Subject();
        this.fields = {
            showAdditionalAnswerForQuestions: false,
            showDividerBeforeForeignCompany: false,
            showForeignCompany: false,
            showRelationshipOfUSCompanyWithForeignCompany: false,
            showTreatyCountry: false
        };
        this.additionalInfoTextAnswerRequiredVisaTypeArray = ['L1A', 'L1B', 'E1', 'E2', 'E2C', 'O1A', 'O1B', 'TN1', 'TN2', 'H1-B'];
        this.isExtension = false;
        this.duplicatePetitionerList = {
            petitionType: [],
            company: [],
            beneficiaryList: [],
            selectedPetitionType: [],
            visaType: '',
            selectedBeneficiaryId: 0
        };
        this.isDuplicatedData = false;
        this.lawFirmUsersList = [];
        this.selectedLawFirmUsers = [];
        this.selectedLawFirmUsersTextArr = [];
        this.petitionTaskForm = this.fb.group({
            authorizedSignatoryId: [null, Validators.required],
            processingType: [null],
            serviceCenterId: [null],
            attorneyId: [null],
            immSpecialistId: [null, Validators.required],
            preparerAttorneyId: [null],
            immigrantTypeCode: [null],
            isAttorneySame: [0],
            isCaseTransferred: [0],
            selectedDesignation: [null],
            questionAndResponseDTO: this.fb.array([]),
            lawFirmUsers: [null]
        });
    }
    ngOnInit() {
        this.visaType = this.parentFormGroup.get('visaType').value;
        this.postNgOnInit();
        switch (this.visaType) {
            case 'L1A':
            case 'L1B':
                this.petitionTaskForm.patchValue({
                    immigrantTypeCode: 'VISA'
                });
                this.petitionTaskForm.addControl('companyRelationCode', new FormControl(null, Validators.required));
                this.petitionTaskForm.addControl('foreignCompanyId', new FormControl(null, Validators.required));
                this.fields = {
                    showAdditionalAnswerForQuestions: true,
                    showDividerBeforeForeignCompany: true,
                    showForeignCompany: true,
                    showRelationshipOfUSCompanyWithForeignCompany: true,
                    showTreatyCountry: false
                };
                break;
            case 'E1':
            case 'E2':
            case 'E2C':
                this.petitionTaskForm.patchValue({
                    immigrantTypeCode: 'VISA'
                });
                this.petitionTaskForm.addControl('companyRelationCode', new FormControl(null, Validators.required));
                this.petitionTaskForm.addControl('foreignCompanyId', new FormControl(null, Validators.required));
                this.petitionTaskForm.addControl('treatyCountry', new FormControl(null));
                this.fields = {
                    showAdditionalAnswerForQuestions: true,
                    showDividerBeforeForeignCompany: true,
                    showForeignCompany: true,
                    showRelationshipOfUSCompanyWithForeignCompany: true,
                    showTreatyCountry: true
                };
                break;
            case 'O1A':
            case 'O1B':
                this.petitionTaskForm.addControl('fieldExtrAbltyCode', new FormControl(null, Validators.required));
                this.petitionTaskForm.addControl('extrAblDocEvdCatgCode', new FormControl('', Validators.required));
                this.petitionTaskForm.addControl('applicableOptionIds', this.fb.array([]));
                this.petitionTaskForm.addControl('applicableOptionCodes', this.fb.array([]));
                // this.petitionTaskForm.setValidators(this.applicableOptionIdsRequired());
                this.fields = {
                    showAdditionalAnswerForQuestions: true,
                    showDividerBeforeForeignCompany: false,
                    showForeignCompany: false,
                    showRelationshipOfUSCompanyWithForeignCompany: false,
                    showTreatyCountry: false
                };
                this.getExtraOrdinaryDetailsOVisa();
                break;
            case 'H1B':
            case 'H1-B':
            case 'TN1':
            case 'TN2':
                this.fields = {
                    showAdditionalAnswerForQuestions: true,
                    showDividerBeforeForeignCompany: false,
                    showForeignCompany: false,
                    showRelationshipOfUSCompanyWithForeignCompany: false,
                    showTreatyCountry: false
                };
                break;
            case 'O1A':
            case 'O1B':
                this.petitionTaskForm.addControl('fieldExtrAbltyCode', new FormControl(null, Validators.required));
                this.petitionTaskForm.addControl('extrAblDocEvdCatgCode', new FormControl('', Validators.required));
                this.petitionTaskForm.addControl('applicableOptionIds', this.fb.array([]));
                this.petitionTaskForm.addControl('applicableOptionCodes', this.fb.array([]));
                // this.petitionTaskForm.setValidators(this.applicableOptionIdsRequired());
                this.fields = {
                    showAdditionalAnswerForQuestions: true,
                    showDividerBeforeForeignCompany: false,
                    showForeignCompany: false,
                    showRelationshipOfUSCompanyWithForeignCompany: false,
                    showTreatyCountry: false
                };
                this.getExtraOrdinaryDetailsOVisa();
                break;
            case 'TN1':
            case 'TN2':
                this.fields = {
                    showAdditionalAnswerForQuestions: true,
                    showDividerBeforeForeignCompany: false,
                    showForeignCompany: false,
                    showRelationshipOfUSCompanyWithForeignCompany: false,
                    showTreatyCountry: false
                };
                break;
        }
        if (this.petitionTaskForm) {
            for (const [key, value] of Object.entries(this.petitionTaskForm.controls)) {
                this.parentFormGroup.addControl(key, value);
            }
        }
        this.userType = sessionStorage.getItem('userTypeRole');
        this.primaryCompanyId = parseInt(sessionStorage.getItem('companyId'));
        combineLatest([
            this.apiService.getReviewersUser(this.parentFormGroup.get('companyId').value, USER_PERMISSIONS.PETITION_REVIEWER),
            this.apiService.getActiveAttorneyCompanyList(sessionStorage.getItem('companyId')),
            this.apiService.getUsersOfCompany(this.parentFormGroup.get('companyId').value),
            this.referenceLibraryService.getReferenceData('USFORGNCOMPREL')
        ])
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(data => {
            this.reviewUsersList = data[0] || [];
            this.attorneys = Object.assign([], [{ attorneyId: null, attorneyName: "Select attorney" }, ...data[1]]);
            this.users = data[2];
            this.companyRelationList = data[3];
            this.petitionTaskForm.patchValue({
                authorizedSignatoryId: this.parentFormGroup.value.authorizedSignatoryId,
                selectedDesignation: '',
                immSpecialistId: this.subTaskDetails && this.subTaskDetails.immSpecialistId,
                processingType: this.subTaskDetails && this.subTaskDetails.processingType
            });
            this.onPetitionerPreparerSelected();
            if (this.parentFormGroup.value.authorizedSignatoryId) {
                this.userSelected();
            }
            if (this.subTaskDetails && this.subTaskDetails.processingType) {
                this.onChangeProcessingType();
            }
            if (this.userType !== 'Attorney') {
                this.petitionTaskForm.patchValue({
                    attorneyId: this.subTaskDetails && this.subTaskDetails.attorneyId,
                    preparerAttorneyId: 0
                });
                this.isAttorneySelect = true;
                switch (this.visaType) {
                    case 'L1A':
                    case 'L1B':
                        this.apiService.getPetitionerClientList(this.parentFormGroup.get('companyId').value, 'notInCountry')
                            .pipe(take(1))
                            .subscribe((response) => {
                            var _a;
                            this.foreignCompanyList = response;
                            if (this.foreignCompanyList.length && this.subTaskDetails && this.subTaskDetails.foreignCompanyId) {
                                this.petitionTaskForm.patchValue({
                                    foreignCompanyId: this.subTaskDetails.foreignCompanyId,
                                    companyRelationCode: (_a = this.subTaskDetails) === null || _a === void 0 ? void 0 : _a.foreignCompanyRelationCode
                                });
                                this.onForeignCompanyChange();
                            }
                            this.getQuestionListForCreateTask();
                        });
                        break;
                    case 'E1':
                    case 'E2':
                    case 'E2C':
                        this.apiService.getForeignCompanyListForEVisa(this.visaType, this.parentFormGroup.get('companyId').value)
                            .pipe(take(1))
                            .subscribe((response) => {
                            var _a;
                            this.foreignCompanyList = response;
                            if (this.foreignCompanyList.length && this.subTaskDetails && this.subTaskDetails.foreignCompanyId) {
                                this.petitionTaskForm.patchValue({
                                    foreignCompanyId: this.subTaskDetails.foreignCompanyId,
                                    companyRelationCode: (_a = this.subTaskDetails) === null || _a === void 0 ? void 0 : _a.foreignCompanyRelationCode
                                });
                                this.onForeignCompanyChange();
                            }
                            this.getQuestionListForCreateTask();
                        });
                        break;
                    default:
                        this.getQuestionListForCreateTask();
                }
            }
            else {
                this.isAttorneySelect = false;
                if (this.parentFormGroup.get('companyId').value) {
                    this.getForeignCompanyListForAttorney();
                }
                this.apiService.getEmployeeDetails(this.primaryCompanyId, parseInt(sessionStorage.getItem('employeeId')))
                    .pipe(take(1))
                    .subscribe((response) => {
                    this.employeeDetails = response;
                    // sessionStorage.setItem("setPreparerAttorneyId", this.employeeDetails['id']);
                    this.petitionTaskForm.patchValue({
                        attorneyId: response.companyId,
                    });
                    this.attorneySelected();
                    this.getQuestionListForCreateTask();
                });
            }
        });
    }
    // applicableOptionIdsRequired(): ValidatorFn {
    //   return (group: FormGroup): { [s: string]: boolean } => {
    //     // console.log(this.petitionTaskForm.value);
    //     console.log(group.value.extrAblDocEvdCatgCode);
    //     if (this.petitionTaskForm.get('extrAblDocEvdCatgCode').value && this.petitionTaskForm.get('extrAblDocEvdCatgCode').value === 'OTHERDOCEVDN' && group.value.applicableOptionIds.length < 3) {
    //       return { applicableOptionIdsIsRequired: true };
    //     }
    //     return null;
    //   }
    // }
    postNgOnInit() {
        // Get Specific Task Details
        if (this.subTaskDetails) {
            // console.log('subTaskDetails:',this.subTaskDetails);
            if (this.subTaskDetails.taskTypeId) {
                sessionStorage.setItem("taskTypeId", JSON.parse(JSON.stringify(this.subTaskDetails.taskTypeId)));
            }
            if (this.subTaskDetails.taskTypeDetails.petitionType === 'EXTNSN' || this.subTaskDetails.taskTypeDetails.petitionType === 'AMEND') {
                this.duplicatePetitionerList.selectedPetitionType = this.subTaskDetails.taskTypeDetails.petitionType;
                this.isExtension = true;
                sessionStorage.setItem('isDuplicated', 'TRUE');
            }
            else {
                this.isExtension = false;
                sessionStorage.removeItem('isDuplicated');
            }
            if (this.subTaskDetails.taskTypeDetails.visaType) {
                this.duplicatePetitionerList.visaType = this.subTaskDetails.taskTypeDetails.visaType;
            }
        }
    }
    onForeignCompanyChange() {
        if (['E1', 'E2', 'E2C'].includes(this.visaType)) {
            this.petitionTaskForm.patchValue({
                treatyCountry: this.foreignCompanyList.find(x => x.id === this.petitionTaskForm.get('foreignCompanyId').value).countryName
            });
        }
    }
    get applicableOptionGroups() {
        return this.petitionTaskForm.get('applicableOptionIds').controls;
    }
    clickRadioBtn(extrAblDocEvdCatgCode) {
        this.petitionTaskForm.get('applicableOptionIds').patchValue(this.petitionTaskForm.get('applicableOptionIds').value.map((x, i) => {
            if (x) {
                this.updateCheckedOptions(false, this.majorInternationAwardList[i].code);
            }
            return false;
        }));
    }
    updateCheckedOptions(checked, code) {
        const applicableOptionIds = this.petitionTaskForm.get('applicableOptionCodes').value;
        if (checked) {
            if (!applicableOptionIds.includes(code)) {
                this.petitionTaskForm.get('applicableOptionCodes').push(new FormControl(code));
            }
        }
        else {
            if (applicableOptionIds.includes(code)) {
                this.petitionTaskForm.get('applicableOptionCodes').removeAt(applicableOptionIds.indexOf(code));
            }
        }
    }
    getExtraOrdinaryDetailsOVisa() {
        let fieldExtrAbltyCode;
        let payload;
        if (this.visaType === 'O1A') {
            fieldExtrAbltyCode = 'O1AFLDEXTRABL';
            payload = ['OTHERDOCEVDN'];
        }
        else {
            fieldExtrAbltyCode = 'O1BFLDEXTRABL';
            payload = ['OTHERDOCEVDN', 'O1BSPECDOCEVDN'];
        }
        combineLatest([
            this.referenceLibraryService.getReferenceData('EXTRABLDOCEVDNCATG'),
            this.referenceLibraryService.postReferenceData(payload),
            this.referenceLibraryService.getReferenceData(fieldExtrAbltyCode)
        ]).pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(data => {
            this.extraBLDOCEVDNCATGList = data[0];
            this.majorInternationAwardList = data[1];
            const applicableOptionIdsFormArray = this.petitionTaskForm.get('applicableOptionIds');
            applicableOptionIdsFormArray.clear();
            this.majorInternationAwardList.forEach(() => {
                applicableOptionIdsFormArray.push(new FormControl(false));
            });
            // console.log(applicableOptionIdsFormArray.value);
            this.fieldExtrAbltyCodeList = data[2];
            this.petitionTaskForm.patchValue({
                extrAblDocEvdCatgCode: this.extraBLDOCEVDNCATGList[0].code
            });
        });
    }
    getForeignCompanyListForAttorney() {
        switch (this.visaType) {
            case 'L1A':
            case 'L1B':
                this.apiService.getPetitionerClientList(this.parentFormGroup.get('companyId').value, 'notInCountry')
                    .pipe(take(1))
                    .subscribe((response) => {
                    var _a;
                    this.foreignCompanyList = response;
                    if (this.foreignCompanyList.length && this.subTaskDetails && this.subTaskDetails.foreignCompanyId) {
                        this.petitionTaskForm.patchValue({
                            foreignCompanyId: this.subTaskDetails.foreignCompanyId,
                            companyRelationCode: (_a = this.subTaskDetails) === null || _a === void 0 ? void 0 : _a.foreignCompanyRelationCode
                        });
                        this.onForeignCompanyChange();
                    }
                });
                break;
            case 'E1':
            case 'E2':
            case 'E2C':
                this.apiService.getForeignCompanyListForEVisa(this.visaType, this.parentFormGroup.get('companyId').value)
                    .pipe(take(1))
                    .subscribe((response) => {
                    var _a;
                    this.foreignCompanyList = response;
                    if (this.foreignCompanyList.length && this.subTaskDetails && this.subTaskDetails.foreignCompanyId) {
                        this.petitionTaskForm.patchValue({
                            foreignCompanyId: this.subTaskDetails.foreignCompanyId,
                            companyRelationCode: (_a = this.subTaskDetails) === null || _a === void 0 ? void 0 : _a.foreignCompanyRelationCode
                        });
                        this.onForeignCompanyChange();
                    }
                });
                break;
        }
    }
    getFormQuestionsArray() {
        return this.petitionTaskForm.get('questionAndResponseDTO').controls;
    }
    getQuestionListForCreateTask() {
        this.isOutsideImagility = this.parentFormGroup.get('isOutsideImagility').value;
        let quesCategory;
        switch (this.visaType) {
            case 'H1-B':
                quesCategory = 'TASKQUES';
                break;
            default:
                quesCategory = 'VISAQUECTGTYP';
                break;
        }
        this.apiService.getTaskQuestioneryOnCategory(quesCategory)
            .pipe(take(1))
            .subscribe((response) => {
            this.questionList = response.map((item, index) => {
                return Object.assign(Object.assign({}, item), { answer: !!(item.answer && item.answer === 1), isAdditionalInfoRequired: !(index > 1) });
            });
            const questionAndResponseDTO = this.parentFormGroup.get('questionAndResponseDTO');
            questionAndResponseDTO.clear();
            this.questionList.forEach((x, index) => {
                questionAndResponseDTO.push(this.createQuestionList(x));
            });
        });
    }
    createQuestionList(item) {
        const savedItem = this.subTaskDetails && this.subTaskDetails.questionAndResponseDTO.find((x) => x.id === item.id);
        return new FormGroup({
            answer: new FormControl(savedItem ? Boolean(savedItem.answer) : item.answer),
            id: new FormControl(item.response && item.response.id ? item.response.id : null),
            questionId: new FormControl(item.id),
            isBoolean: new FormControl(true),
            additionalInfo: new FormControl(savedItem ? savedItem.additionalInfo : null),
            sequenceNumber: new FormControl(item.sequenceNumber),
            question: new FormControl(item.question)
        }, (item === null || item === void 0 ? void 0 : item.isAdditionalInfoRequired) ? this.additionalInfoRequired.bind(this) : null);
    }
    additionalInfoRequired(group) {
        if (!this.isOutsideImagility && this.additionalInfoTextAnswerRequiredVisaTypeArray.includes(this.visaType) &&
            group.value.answer && !group.value.additionalInfo) {
            return { additionalInfoIsRequired: true };
        }
        return null;
    }
    onQuestionToggle(questionIndex, answer) {
        if (!answer) {
            const questionGroup = this.parentFormGroup.get('questionAndResponseDTO').controls[questionIndex];
            questionGroup.patchValue({
                additionalInfo: null
            });
        }
    }
    onChangeProcessingType() {
        this.serviceCenters = [];
        this.getServiceCenter();
    }
    getServiceCenter() {
        const processingType = this.petitionTaskForm.get('processingType').value;
        const petitionType = this.parentFormGroup.get('petitionType').value;
        this.apiService.getServiceCenters((processingType === 'regular') ? 'false' : 'true', this.visaType, petitionType)
            .subscribe((data) => {
            this.serviceCenters = data;
            if (this.subTaskDetails && this.subTaskDetails.serviceCenterId) {
                this.petitionTaskForm.patchValue({ serviceCenterId: this.subTaskDetails.serviceCenterId });
            }
        });
    }
    userSelected() {
        const id = this.petitionTaskForm.get('authorizedSignatoryId').value;
        this.selectedSignatory = this.reviewUsersList.find(ele => ele.id === id);
        this.petitionTaskForm.patchValue({
            selectedDesignation: this.selectedSignatory.designation,
        });
        this.selectedDesignation = this.selectedSignatory.designation;
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    attorneySelected() {
        const attorneyId = this.petitionTaskForm.get('attorneyId').value;
        if (attorneyId && attorneyId !== '') {
            combineLatest([
                this.apiService.getReviewersUser(attorneyId, USER_PERMISSIONS.PETITION_REVIEWER),
                this.apiService.getUsersOfCompany(attorneyId),
            ])
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe(data => {
                this.attorneyUsers = data ? data[0] : [];
                this.lawFirmUsersList = data ? data[1] : [];
                if (this.subTaskDetails && this.subTaskDetails.preparerAttorneyId) {
                    this.petitionTaskForm.patchValue({ preparerAttorneyId: this.subTaskDetails.preparerAttorneyId });
                    this.userPreparerSelected();
                }
                if (this.subTaskDetails && this.subTaskDetails.lawFirmUsers) {
                    this.petitionTaskForm.patchValue({ lawFirmUsers: this.subTaskDetails.lawFirmUsers });
                    this.usersLawFrimSelected();
                }
            });
        }
        else {
            this.attorneyUsers = [];
            this.lawFirmUsersList = [];
        }
    }
    userPreparerSelected() {
        sessionStorage.setItem("setPreparerAttorneyId", "undefined");
        const id = this.petitionTaskForm.get('preparerAttorneyId').value;
        this.selectedPreparer = this.attorneyUsers.find(ele => ele.id === id);
    }
    usersLawFrimSelected() {
        const ids = this.petitionTaskForm.get('lawFirmUsers').value;
        this.selectedLawFirmUsers = ids.length ? this.lawFirmUsersList.filter(ele => ids.includes(ele.id)) : [];
        this.selectedLawFirmUsersTextArr = [];
        this.selectedLawFirmUsers.forEach((el) => {
            this.selectedLawFirmUsersTextArr.push(`${el.firstName} ${el.lastName}`);
        });
    }
    onPetitionerPreparerSelected() {
        const id = this.petitionTaskForm.get('immSpecialistId').value;
        this.selectedPetetionPreprarer = this.users.find(ele => ele.id === id);
    }
    isDuplicatedtoggle(e, checked) {
        // console.log(e,checked);
        if (e === 'duplicated') {
            this.isDuplicatedData = checked;
        }
    }
    ngOnDestroy() {
        if (this.ngUnsubscribe) {
            this.ngUnsubscribe.next();
            this.ngUnsubscribe.complete();
        }
        if (this.petitionTaskForm) {
            for (const [key, value] of Object.entries(this.petitionTaskForm.controls)) {
                this.parentFormGroup.removeControl(key);
            }
        }
        sessionStorage.setItem("setPreparerAttorneyId", "undefined");
    }
}
PetitionTaskComponent.ɵfac = function PetitionTaskComponent_Factory(t) { return new (t || PetitionTaskComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.ReferenceLibraryService), i0.ɵɵdirectiveInject(PetitionTaskService)); };
PetitionTaskComponent.ɵcmp = i0.ɵɵdefineComponent({ type: PetitionTaskComponent, selectors: [["app-petition-task"]], inputs: { parentFormGroup: "parentFormGroup", subTaskDetails: "subTaskDetails" }, decls: 30, vars: 10, consts: [[1, "p-mt-2", 3, "formGroup"], [4, "ngIf"], ["class", "p-grid dashed-line p-my-4", 4, "ngIf"], ["class", "p-fluid p-formgrid p-grid", 4, "ngIf"], [1, "p-grid", "dashed-line", "p-my-4"], [1, "p-fluid", "p-formgrid", "p-grid"], [1, "p-col-4"], [1, "create-task-label", "required"], ["formControlName", "authorizedSignatoryId", "name", "authorizedSignatoryId", "optionLabel", "firstName", "optionValue", "id", "placeholder", "Select Signatory", 3, "options", "onChange"], ["pTemplate", "selectedItem"], ["pTemplate", "item"], ["class", "invalid-message", 4, "ngIf"], [1, "create-task-label"], ["type", "text", "readOnly", "", "name", "selectedDesignation", "formControlName", "selectedDesignation", 1, "form-control", "txt-comp"], ["formControlName", "immSpecialistId", "name", "immSpecialistId", "optionLabel", "firstName", "optionValue", "id", "placeholder", "Select Petitioner Preparer", "appendTo", "body", 3, "options", "onChange"], ["class", "p-grid", 4, "ngIf"], ["formArrayName", "questionAndResponseDTO", 4, "ngFor", "ngForOf"], [1, "p-grid"], [1, "p-col-9"], [1, "create-task-label", "question", "required"], ["name", "create-task-label question", 1, "p-col-12", "mb-2"], ["formControlName", "fieldExtrAbltyCode", "name", "fieldExtrAbltyCode", "optionLabel", "name", "optionValue", "code", "placeholder", "Select field of extraordinary ability", 1, "extra-ordinary-dropdown", 3, "options"], ["for", "tasktype", 1, "create-task-label", "question", "required"], [1, "p-col-12"], [1, "p-col-10"], ["name", "extrAblDocEvdCatgCode", "formControlName", "extrAblDocEvdCatgCode", "inputId", "extrAblDocEvdCatgCode0", 3, "value", "label", "click"], [1, "p-grid", "mt-2", "mb-2", "ml-1"], ["name", "extrAblDocEvdCatgCode", "formControlName", "extrAblDocEvdCatgCode", "inputId", "extrAblDocEvdCatgCode1", 3, "value", "label", "click"], [1, "p-grid", "mt-2", "mb-2"], ["class", "p-col-12", "formArrayName", "applicableOptionIds", 4, "ngFor", "ngForOf"], [1, "invalid-message"], ["formArrayName", "applicableOptionIds", 1, "p-col-12"], ["binary", "true", "name", "applicableOption", 3, "disabled", "formControlName", "label", "onChange"], ["formArrayName", "questionAndResponseDTO"], [3, "formGroupName"], ["name", "create-task-label question", 1, "p-col-9"], ["class", "p-col-1", 4, "ngIf"], ["class", "mt-3 p-col-12", 4, "ngIf"], [1, "p-col-1"], ["color", "primary", "name", "answer", "formControlName", "answer", 3, "toggleChange"], ["class", "p-col-5", 4, "ngIf"], ["class", "p-col-10", 4, "ngIf"], [1, "p-col-5"], ["styleClass", "create-task-input", "placeholder", "Enter", "formControlName", "additionalInfo", 1, "d-block", 3, "min", "max", "maxlength", "useGrouping"], ["rows", "3", "formControlName", "additionalInfo", "placeholder", "Enter", "pInputTextarea", "", "autoResize", "autoResize", 1, "create-task-textarea", "d-block", "p-inputtext"], [1, "mt-3", "p-col-12"], ["type", "text", "placeholder", "Enter", "formControlName", "additionalInfo", 1, "im-input", "mb-4"], ["class", "p-col-4", 4, "ngIf"], ["formControlName", "foreignCompanyId", "name", "foreignCompanyId", "optionLabel", "companyName", "optionValue", "id", "placeholder", "Select", 3, "options", "onChange"], ["class", "p-error", 4, "ngIf"], [1, "p-error"], ["formControlName", "companyRelationCode", "name", "companyRelationCode", "optionLabel", "name", "optionValue", "code", "placeholder", "Select", 3, "options"], ["type", "text", "pInputText", "", "formControlName", "treatyCountry", 1, "form-control", "txt-comp", 3, "readonly"], ["formControlName", "attorneyId", "name", "attorneyId", "optionLabel", "attorneyName", "optionValue", "attorneyId", "placeholder", "Select attorney", 3, "options", "onChange"], ["formControlName", "preparerAttorneyId", "name", "preparerAttorneyId", "optionLabel", "firstName", "optionValue", "id", "placeholder", "Select Preparer", 3, "options", "onChange"], [1, "labelText"], [1, "p-col-12", "pl-0"], [1, "mt-2", "ml-2", "create-task-label", "label-cls"], [1, "row", "mt-1", "ml-2"], [1, "mt-2", "d-block", "create-task-label"], ["formControlName", "preparerAttorneyId", "name", "preparerAttorneyId", "optionLabel", "firstName", "optionValue", "id", "placeholder", "Select", 1, "w-100", 3, "options", "onChange"], ["optionValue", "id", "formControlName", "lawFirmUsers", "appendTo", "body", "defaultLabel", "Select", "optionLabel", "firstName", 1, "w-100", 3, "options", "onChange"], ["pTemplate", "selectedItems"]], template: function PetitionTaskComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div");
        i0.ɵɵelementStart(1, "div", 0);
        i0.ɵɵtemplate(2, PetitionTaskComponent_div_2_Template, 3, 2, "div", 1);
        i0.ɵɵtemplate(3, PetitionTaskComponent_div_3_Template, 1, 0, "div", 2);
        i0.ɵɵtemplate(4, PetitionTaskComponent_div_4_Template, 4, 3, "div", 3);
        i0.ɵɵelement(5, "div", 4);
        i0.ɵɵelementStart(6, "div", 5);
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelementStart(8, "label", 7);
        i0.ɵɵtext(9, "Signatory Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "p-dropdown", 8);
        i0.ɵɵlistener("onChange", function PetitionTaskComponent_Template_p_dropdown_onChange_10_listener() { return ctx.userSelected(); });
        i0.ɵɵtemplate(11, PetitionTaskComponent_ng_template_11_Template, 1, 1, "ng-template", 9);
        i0.ɵɵtemplate(12, PetitionTaskComponent_ng_template_12_Template, 3, 1, "ng-template", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, PetitionTaskComponent_span_13_Template, 2, 1, "span", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 6);
        i0.ɵɵelementStart(15, "label", 12);
        i0.ɵɵtext(16, "Designation");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(17, "input", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(18, "div", 4);
        i0.ɵɵtemplate(19, PetitionTaskComponent_div_19_Template, 12, 2, "div", 1);
        i0.ɵɵtemplate(20, PetitionTaskComponent_div_20_Template, 21, 3, "div", 1);
        i0.ɵɵelement(21, "div", 4);
        i0.ɵɵelementStart(22, "div", 5);
        i0.ɵɵelementStart(23, "div", 6);
        i0.ɵɵelementStart(24, "label", 7);
        i0.ɵɵtext(25, "Petitioner preparer name");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "p-dropdown", 14);
        i0.ɵɵlistener("onChange", function PetitionTaskComponent_Template_p_dropdown_onChange_26_listener() { return ctx.onPetitionerPreparerSelected(); });
        i0.ɵɵtemplate(27, PetitionTaskComponent_ng_template_27_Template, 1, 1, "ng-template", 9);
        i0.ɵɵtemplate(28, PetitionTaskComponent_ng_template_28_Template, 3, 1, "ng-template", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(29, PetitionTaskComponent_span_29_Template, 2, 1, "span", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formGroup", ctx.petitionTaskForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isOutsideImagility);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fields.showDividerBeforeForeignCompany);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fields.showForeignCompany || ctx.fields.showRelationshipOfUSCompanyWithForeignCompany || ctx.fields.showTreatyCountry);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("options", ctx.reviewUsersList);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.petitionTaskForm.get("authorizedSignatoryId").touched && (ctx.petitionTaskForm.get("authorizedSignatoryId").errors == null ? null : ctx.petitionTaskForm.get("authorizedSignatoryId").errors.required));
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("ngIf", ctx.isAttorneySelect);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isAttorneySelect);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("options", ctx.users);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.petitionTaskForm.get("immSpecialistId").touched && (ctx.petitionTaskForm.get("immSpecialistId").errors == null ? null : ctx.petitionTaskForm.get("immSpecialistId").errors.required));
    } }, directives: [i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i9.NgIf, i5.Dropdown, i1$1.NgControlStatus, i1$1.FormControlName, i6.PrimeTemplate, i1$1.DefaultValueAccessor, i9.NgForOf, i7.RadioButton, i1$1.FormArrayName, i8.Checkbox, i1$1.FormGroupName, i9$1.InputSwitch, i10.InputNumber, i1$1.MaxLengthValidator, i11.InputTextarea, i12.InputText, i13.MultiSelect], styles: ["[_nghost-%COMP%]   .mat-slide-toggle.mat-checked[_ngcontent-%COMP%]    .mat-slide-toggle-bar:after{content:\"Yes\";font-size:50%;font-weight:700;color:#fff;position:absolute;left:4px;top:-5px}[_nghost-%COMP%]   .mat-slide-toggle[_ngcontent-%COMP%]:not(.mat-checked)    .mat-slide-toggle-bar:after{content:\"No\";font-size:50%;font-weight:700;color:#fff;position:absolute;left:21px;top:-5px}[_nghost-%COMP%]   .mat-slide-toggle[_ngcontent-%COMP%]   .mat-primary.mat-checked[_ngcontent-%COMP%]   .mat-slide-toggle-thumb[_ngcontent-%COMP%]{background-color:#30b1e1!important}  .mat-slide-toggle.mat-primary.mat-checked:not(.mat-disabled) .mat-slide-toggle-bar,   .mat-slide-toggle.mat-primary.mat-checked:not(.mat-disabled) .mat-slide-toggle-thumb{background-color:#30b1e1}.create-task-label[_ngcontent-%COMP%]{font-size:14px!important}input[readonly][_ngcontent-%COMP%]{background-color:#f1f1f1!important;border:1px solid #c3d0de!important;box-shadow:none!important;height:40px!important}.extra-ordinary-dropdown[_ngcontent-%COMP%]{display:grid}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PetitionTaskComponent, [{
        type: Component,
        args: [{
                selector: 'app-petition-task',
                templateUrl: './petition-task.component.html',
                styleUrls: ['./petition-task.component.scss']
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.ReferenceLibraryService }, { type: PetitionTaskService }]; }, { parentFormGroup: [{
            type: Input
        }], subTaskDetails: [{
            type: Input
        }] }); })();

function CreateTaskLibraryComponent_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CreateTaskLibraryComponent_div_15_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CreateTaskLibraryComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "label", 17);
    i0.ɵɵtext(2, "Visa Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 18);
    i0.ɵɵlistener("onChange", function CreateTaskLibraryComponent_div_15_Template_p_dropdown_onChange_3_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.getPetitionType(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CreateTaskLibraryComponent_div_15_span_4_Template, 2, 1, "span", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r1.visaTypes)("disabled", !ctx_r1.newTaskForm.get("superTaskTypeCode").value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.newTaskForm.get("visaType").touched && (ctx_r1.newTaskForm.get("visaType").errors == null ? null : ctx_r1.newTaskForm.get("visaType").errors.required));
} }
function CreateTaskLibraryComponent_div_16_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r15.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CreateTaskLibraryComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "label", 19);
    i0.ɵɵtext(2, "Immigration Category");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "p-dropdown", 20);
    i0.ɵɵtemplate(4, CreateTaskLibraryComponent_div_16_span_4_Template, 2, 1, "span", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r2.visaTypes)("disabled", !ctx_r2.newTaskForm.get("superTaskTypeCode").value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.newTaskForm.get("immCategoryCode").touched && (ctx_r2.newTaskForm.get("immCategoryCode").errors == null ? null : ctx_r2.newTaskForm.get("immCategoryCode").errors.required));
} }
function CreateTaskLibraryComponent_div_18_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CreateTaskLibraryComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "label", 21);
    i0.ɵɵtext(2, "Petition Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 22);
    i0.ɵɵlistener("onChange", function CreateTaskLibraryComponent_div_18_Template_p_dropdown_onChange_3_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.getSubTaskType(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CreateTaskLibraryComponent_div_18_span_4_Template, 2, 1, "span", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r3.petitionTypes)("disabled", !ctx_r3.newTaskForm.get("visaType").value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.newTaskForm.get("petitionType").touched && (ctx_r3.newTaskForm.get("petitionType").errors == null ? null : ctx_r3.newTaskForm.get("petitionType").errors.required));
} }
function CreateTaskLibraryComponent_div_19_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r19.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CreateTaskLibraryComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "label", 23);
    i0.ɵɵtext(2, "Immigration Classification");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 24);
    i0.ɵɵlistener("onChange", function CreateTaskLibraryComponent_div_19_Template_p_dropdown_onChange_3_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.onChangeImmigrationClassification(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CreateTaskLibraryComponent_div_19_span_4_Template, 2, 1, "span", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r4.petitionTypes)("disabled", !ctx_r4.newTaskForm.get("immCategoryCode").value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.newTaskForm.get("immClassificationCode").touched && (ctx_r4.newTaskForm.get("immClassificationCode").errors == null ? null : ctx_r4.newTaskForm.get("immClassificationCode").errors.required));
} }
function CreateTaskLibraryComponent_div_20_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r22.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CreateTaskLibraryComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "label", 26);
    i0.ɵɵtext(2, "Company");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 27);
    i0.ɵɵlistener("onChange", function CreateTaskLibraryComponent_div_20_Template_p_dropdown_onChange_3_listener() { i0.ɵɵrestoreView(_r24); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.fetchPetitionerBeneficiary(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CreateTaskLibraryComponent_div_20_span_4_Template, 2, 1, "span", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r5.petitionerCompanyList)("disabled", !(ctx_r5.newTaskForm.get("petitionType").value || ctx_r5.newTaskForm.get("immClassificationCode").value));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.newTaskForm.get("companyId").touched && (ctx_r5.newTaskForm.get("companyId").errors == null ? null : ctx_r5.newTaskForm.get("companyId").errors.required));
} }
function CreateTaskLibraryComponent_div_21_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r25.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CreateTaskLibraryComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "label", 26);
    i0.ɵɵtext(2, "Company");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 28);
    i0.ɵɵlistener("onChange", function CreateTaskLibraryComponent_div_21_Template_p_dropdown_onChange_3_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(); return ctx_r26.onAttorneyCompanyChange(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CreateTaskLibraryComponent_div_21_span_4_Template, 2, 1, "span", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r6.companyListAssociatedWithAttorney)("disabled", !(ctx_r6.newTaskForm.get("petitionType").value || ctx_r6.newTaskForm.get("immClassificationCode").value));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.newTaskForm.get("companyId").touched && (ctx_r6.newTaskForm.get("companyId").errors == null ? null : ctx_r6.newTaskForm.get("companyId").errors.required));
} }
function CreateTaskLibraryComponent_a_23_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 29);
    i0.ɵɵlistener("click", function CreateTaskLibraryComponent_a_23_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.viewcompany(); });
    i0.ɵɵelementStart(1, "mat-icon", 30);
    i0.ɵɵtext(2, "corporate_fare ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CreateTaskLibraryComponent_div_24_4_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r33 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r33.selectedBeneficiary == null ? null : ctx_r33.selectedBeneficiary.beneficiaryEmployeeFName) + " " + (ctx_r33.selectedBeneficiary == null ? null : ctx_r33.selectedBeneficiary.beneficiaryEmployeeLName));
} }
function CreateTaskLibraryComponent_div_24_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, CreateTaskLibraryComponent_div_24_4_ng_template_0_Template, 3, 1, "ng-template", 34);
} }
function CreateTaskLibraryComponent_div_24_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r34 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", (employee_r34 == null ? null : employee_r34.beneficiaryEmployeeFName) + " " + (employee_r34 == null ? null : employee_r34.beneficiaryEmployeeLName), " ");
} }
function CreateTaskLibraryComponent_div_24_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r32.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CreateTaskLibraryComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "label", 31);
    i0.ɵɵtext(2, "Beneficiary Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 32);
    i0.ɵɵlistener("onChange", function CreateTaskLibraryComponent_div_24_Template_p_dropdown_onChange_3_listener() { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(); return ctx_r35.setBeneCompany(); });
    i0.ɵɵtemplate(4, CreateTaskLibraryComponent_div_24_4_Template, 1, 0, undefined, 10);
    i0.ɵɵtemplate(5, CreateTaskLibraryComponent_div_24_ng_template_5_Template, 3, 1, "ng-template", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, CreateTaskLibraryComponent_div_24_span_6_Template, 2, 1, "span", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r8.beneficiaryList)("disabled", !ctx_r8.newTaskForm.get("companyId").value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.selectedBeneficiary);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r8.newTaskForm.get("beneficiaryId").touched && (ctx_r8.newTaskForm.get("beneficiaryId").errors == null ? null : ctx_r8.newTaskForm.get("beneficiaryId").errors.required));
} }
function CreateTaskLibraryComponent_div_25_4_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r40 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r40.selectedBeneficiary == null ? null : ctx_r40.selectedBeneficiary.beneficiaryEmployeeFName) + " " + (ctx_r40.selectedBeneficiary == null ? null : ctx_r40.selectedBeneficiary.beneficiaryEmployeeLName));
} }
function CreateTaskLibraryComponent_div_25_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, CreateTaskLibraryComponent_div_25_4_ng_template_0_Template, 3, 1, "ng-template", 34);
} }
function CreateTaskLibraryComponent_div_25_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 36);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const employee_r41 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", (employee_r41 == null ? null : employee_r41.beneficiaryEmployeeFName) + " " + (employee_r41 == null ? null : employee_r41.beneficiaryEmployeeLName), " ");
} }
function CreateTaskLibraryComponent_div_25_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r39 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r39.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CreateTaskLibraryComponent_div_25_Template(rf, ctx) { if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "label", 31);
    i0.ɵɵtext(2, "Beneficiary Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 32);
    i0.ɵɵlistener("onChange", function CreateTaskLibraryComponent_div_25_Template_p_dropdown_onChange_3_listener() { i0.ɵɵrestoreView(_r43); const ctx_r42 = i0.ɵɵnextContext(); return ctx_r42.fetchDetailsForAttorney(); });
    i0.ɵɵtemplate(4, CreateTaskLibraryComponent_div_25_4_Template, 1, 0, undefined, 10);
    i0.ɵɵtemplate(5, CreateTaskLibraryComponent_div_25_ng_template_5_Template, 3, 1, "ng-template", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, CreateTaskLibraryComponent_div_25_span_6_Template, 2, 1, "span", 9);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r9.beneficiaryList)("disabled", !ctx_r9.newTaskForm.get("companyId").value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.selectedBeneficiary);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r9.newTaskForm.get("beneficiaryId").touched && (ctx_r9.newTaskForm.get("beneficiaryId").errors == null ? null : ctx_r9.newTaskForm.get("beneficiaryId").errors.required));
} }
function CreateTaskLibraryComponent_a_27_Template(rf, ctx) { if (rf & 1) {
    const _r45 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 29);
    i0.ɵɵlistener("click", function CreateTaskLibraryComponent_a_27_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r45); const ctx_r44 = i0.ɵɵnextContext(); return ctx_r44.viewbeneficiaries(); });
    i0.ɵɵelementStart(1, "mat-icon", 37);
    i0.ɵɵtext(2, "person");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function CreateTaskLibraryComponent_ng_template_29_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵtext(1, " Is Petition Filed Outside Imagility ");
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "create-task-disabled": a0 }; };
function CreateTaskLibraryComponent_ng_template_29_div_0_p_inputSwitch_6_Template(rf, ctx) { if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-inputSwitch", 48);
    i0.ɵɵlistener("onChange", function CreateTaskLibraryComponent_ng_template_29_div_0_p_inputSwitch_6_Template_p_inputSwitch_onChange_0_listener() { i0.ɵɵrestoreView(_r54); const ctx_r53 = i0.ɵɵnextContext(3); return ctx_r53.handleSwitchChange(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c0, ctx_r48.fields.disableIsOutsideImagility))("disabled", ctx_r48.fields.disableIsOutsideImagility);
} }
function CreateTaskLibraryComponent_ng_template_29_div_0_p_dropdown_11_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-dropdown", 49);
    i0.ɵɵlistener("onChange", function CreateTaskLibraryComponent_ng_template_29_div_0_p_dropdown_11_Template_p_dropdown_onChange_0_listener() { i0.ɵɵrestoreView(_r56); const ctx_r55 = i0.ɵɵnextContext(3); return ctx_r55.onChangeSubTaskType(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("options", ctx_r49.subTaskType);
} }
function CreateTaskLibraryComponent_ng_template_29_div_0_p_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 3);
    i0.ɵɵtext(1, "Petition");
    i0.ɵɵelementEnd();
} }
function CreateTaskLibraryComponent_ng_template_29_div_0_span_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r51.getGlobalErrorMessages("REQUIRED"), " ");
} }
function CreateTaskLibraryComponent_ng_template_29_div_0_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 50);
    i0.ɵɵelement(1, "app-petition-task", 51);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("parentFormGroup", ctx_r52.newTaskForm);
} }
function CreateTaskLibraryComponent_ng_template_29_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "h5", 3);
    i0.ɵɵtext(2, "Enter the Sub-Task Details ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 38);
    i0.ɵɵtemplate(4, CreateTaskLibraryComponent_ng_template_29_div_0_div_4_Template, 2, 0, "div", 39);
    i0.ɵɵelementStart(5, "div", 40);
    i0.ɵɵtemplate(6, CreateTaskLibraryComponent_ng_template_29_div_0_p_inputSwitch_6_Template, 1, 4, "p-inputSwitch", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 5);
    i0.ɵɵelementStart(8, "div", 6);
    i0.ɵɵelementStart(9, "label", 42);
    i0.ɵɵtext(10, "Sub-Task Type");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, CreateTaskLibraryComponent_ng_template_29_div_0_p_dropdown_11_Template, 1, 1, "p-dropdown", 43);
    i0.ɵɵtemplate(12, CreateTaskLibraryComponent_ng_template_29_div_0_p_12_Template, 2, 0, "p", 44);
    i0.ɵɵtemplate(13, CreateTaskLibraryComponent_ng_template_29_div_0_span_13_Template, 2, 1, "span", 9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 45);
    i0.ɵɵtemplate(15, CreateTaskLibraryComponent_ng_template_29_div_0_div_15_Template, 2, 1, "div", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(16, "div", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r46 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r46.isImmigrant);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r46.isImmigrant);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", (ctx_r46.newTaskForm.get("isOutsideImagility").value || ctx_r46.isImmigrant) && ctx_r46.subTaskType && ctx_r46.subTaskType.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r46.newTaskForm.get("isOutsideImagility").value && ctx_r46.newTaskForm.get("taskTypeCode").value === "PETITION");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r46.newTaskForm.get("isOutsideImagility").value || ctx_r46.isImmigrant) && ctx_r46.newTaskForm.get("taskTypeCode").touched && (ctx_r46.newTaskForm.get("taskTypeCode").errors == null ? null : ctx_r46.newTaskForm.get("taskTypeCode").errors.required));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r46.newTaskForm.get("taskTypeCode").value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "PETITION");
} }
function CreateTaskLibraryComponent_ng_template_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, CreateTaskLibraryComponent_ng_template_29_div_0_Template, 17, 7, "div", 10);
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", (ctx_r11.newTaskForm.get("petitionType").value || ctx_r11.newTaskForm.get("immClassificationCode").value) && ctx_r11.newTaskForm.get("beneficiaryId").value);
} }
class CreateTaskLibraryComponent {
    constructor(router, referenceLibraryService, toastr, fb, store, createTaskService) {
        this.router = router;
        this.referenceLibraryService = referenceLibraryService;
        this.toastr = toastr;
        this.fb = fb;
        this.store = store;
        this.createTaskService = createTaskService;
        this.companyId = '';
        this.beneficiaryList = [];
        this.immiStatus = [];
        this.steps = [];
        this.users = [];
        this.reviewUsersList = [];
        this.attorneys = [];
        this.immigrantType = '';
        this.beneCompany = "";
        this.taskId = null;
        this.beneficiaryParamPayload = {
            pageNumber: 1,
            recordsPerPage: 100,
            searchCriteria: 'beneficiary',
            searchText: '',
            sortBy: 'companyName',
            sortOrder: 'asc',
            status: ['ACTIVE'] // IM-3352 (IM-3335) user story
        };
        this.taskTypeDetails = null;
        this.petitionId = '';
        this.userType = '';
        this.color = 'green';
        this.checked = false;
        this.disabled = false;
        this.companyListAssociatedWithAttorney = [];
        this.userName = '';
        this.selectedCompanyId = ''; // this is for attorney flow
        this.noticeNumber = '';
        this.isAttorneySame = false;
        this.isCaseTransferred = false;
        this.taskType = 'RFE';
        this.visaTypes = [];
        this.petitionTypes = [];
        this.petitionerCompanyList = [];
        this.isViewcompany = false;
        this.selectedBeneficiary = {};
        this.isViewBeneficiary = false;
        this.destroy$ = new Subject();
        this.selectedSubTask = '';
        this.isImmigrant = false;
        this.petitionerForeignCompanyList = [];
        this.attorneyForeignCompanyList = [];
        this.fields = {
            disableIsOutsideImagility: false
        };
        this.visaTypeArray = VisaTypeList;
        this.OVisaTypeArray = ['O1A', 'O1B'];
        this.viewBeneficiaryProfile = new EventEmitter();
        this.viewCompanyProfile = new EventEmitter();
        this.onTaskDetailsChange = new EventEmitter();
        this.newTaskForm = this.fb.group({
            id: [null],
            beneficiaryId: [null, Validators.required],
            companyId: [null, Validators.required],
            petitionType: [null],
            visaType: [null],
            immCategoryCode: [null],
            immClassificationCode: [null],
            taskTypeCode: [null, Validators.required],
            superTaskTypeCode: ['NONIMMPET', Validators.required],
            isOutsideImagility: [false],
        });
    }
    ngOnInit() {
        this.primaryCompanyId = parseInt(sessionStorage.getItem('companyId'));
        this.userType = sessionStorage.getItem('userTypeRole');
        combineLatest([
            this.referenceLibraryService.getReferenceData('IMMTYP'),
            this.referenceLibraryService.getReferenceData('SUPTSKTYP')
        ])
            .pipe(take(1))
            .subscribe((response) => {
            this.immiStatus = response[0];
            this.immigrantType = 'VISA';
            this.taskTypeList = response[1];
            if (this.newTaskForm.get('superTaskTypeCode').value) {
                this.getVisaType();
            }
        });
        this.newTaskForm.valueChanges.pipe(map(() => this.newTaskForm.dirty && this.newTaskForm.enabled), distinctUntilChanged(), takeUntil(this.destroy$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    ngAfterViewInit() {
    }
    backToDashboard() {
        if (this.userType === 'Attorney') {
            this.router.navigate(['attorney-landing/dashboard/attorney-dashboard']);
        }
        else {
            this.router.navigate(['petitioner-landing/dashboard/petitioner-dashboard']);
        }
    }
    getBeneficiaryList(companyId) {
        this.createTaskService.getBeneficiariesByCompanyId(companyId, this.beneficiaryParamPayload).subscribe((data) => {
            if (data) {
                this.beneficiaryList = data;
            }
        });
    }
    getVisaType() {
        this.newTaskForm.patchValue({
            visaType: null,
            petitionType: null,
            taskTypeCode: null,
            immCategoryCode: null,
            immClassificationCode: null,
            companyId: null,
            beneficiaryId: null,
            isOutsideImagility: false
        });
        this.petitionTypes = [];
        this.petitionTypes = [];
        this.petitionerCompanyList = [];
        this.companyListAssociatedWithAttorney = [];
        if (this.newTaskForm.get('superTaskTypeCode').value === 'NONIMMPET') {
            this.isImmigrant = false;
            this.referenceLibraryService.getReferenceData('VISATYP').subscribe((response) => {
                this.petitionTypes = [];
                this.visaTypes = response;
                this.onChangeFilterDropDown();
            });
        }
        else if (this.newTaskForm.get('superTaskTypeCode').value === 'IMMPET') {
            this.isImmigrant = true;
            this.getImmigrantClassificationAndCategory();
        }
    }
    getImmigrantClassificationAndCategory() {
        let companyListReq;
        if (this.userType === 'Petitioner') {
            companyListReq = this.createTaskService.getPetitionerClientList(this.primaryCompanyId);
        }
        else if (this.userType === 'Attorney') {
            const reqJson = {
                searchText: '',
                searchCriteria: '',
                sortBy: '',
                sortOrder: '',
                pageNumber: 0,
                recordsPerPage: 0
            };
            companyListReq = this.createTaskService.getClientsList(this.primaryCompanyId, reqJson);
        }
        combineLatest([
            this.referenceLibraryService.getReferenceData('GCIMMCATG'),
            this.referenceLibraryService.getReferenceData('GCEB'),
            companyListReq
        ])
            .subscribe((response) => {
            this.visaTypes = response[0];
            this.petitionTypes = response[1];
            if (this.userType === 'Petitioner') {
                this.petitionerCompanyList = response[2];
            }
            else if (this.userType === 'Attorney') {
                if (response[2] && response[2].petetionerList) {
                    this.companyListAssociatedWithAttorney = response[2].petetionerList;
                }
            }
            this.onChangeFilterDropDown();
        });
    }
    getPetitionType() {
        this.newTaskForm.patchValue({
            petitionType: null,
            companyId: null,
            beneficiaryId: null,
            taskTypeCode: null,
            isOutsideImagility: false
        });
        let companyListReq;
        switch (this.newTaskForm.get('visaType').value) {
            case 'H1-B':
                if (this.userType === 'Petitioner') {
                    companyListReq = this.createTaskService.getPetitionerClientList(this.primaryCompanyId);
                }
                else if (this.userType === 'Attorney') {
                    const reqJson = {
                        searchText: '',
                        searchCriteria: '',
                        sortBy: '',
                        sortOrder: '',
                        pageNumber: 0,
                        recordsPerPage: 0
                    };
                    companyListReq = this.createTaskService.getClientsList(this.primaryCompanyId, reqJson);
                }
                combineLatest([
                    this.createTaskService.getPetitionList(this.newTaskForm.get('visaType').value),
                    companyListReq
                ])
                    .pipe(take(1))
                    .subscribe((response) => {
                    this.petitionTypes = response[0].map(x => {
                        return {
                            code: x.code,
                            name: x.name,
                            id: x.id,
                            desc: x.description,
                            group: x.group
                        };
                    });
                    if (this.userType === 'Petitioner') {
                        this.petitionerCompanyList = response[1];
                    }
                    else if (this.userType === 'Attorney') {
                        if (response[1] && response[1].petetionerList) {
                            this.companyListAssociatedWithAttorney = response[1].petetionerList;
                        }
                    }
                    this.onChangeFilterDropDown();
                });
                break;
            default:
                this.fields.disableIsOutsideImagility = false;
                const req = [
                    this.createTaskService.getPetitionList(this.newTaskForm.get('visaType').value)
                ];
                if (this.userType === 'Petitioner') {
                    companyListReq = this.createTaskService.getPetitionerClientList(this.primaryCompanyId, 'countryCode');
                    req.push(companyListReq);
                }
                else if (this.userType === 'Attorney') {
                    const reqJson = {
                        searchText: '',
                        searchCriteria: '',
                        sortBy: '',
                        sortOrder: '',
                        pageNumber: 0,
                        recordsPerPage: 0
                    };
                    companyListReq = this.createTaskService.getClientsList(this.primaryCompanyId, reqJson);
                    req.push(companyListReq);
                }
                combineLatest(req)
                    .pipe(take(1))
                    .subscribe((response) => {
                    this.petitionTypes = response[0].map(x => {
                        return {
                            code: x.code,
                            name: x.name,
                            id: x.id,
                            desc: x.description,
                            group: x.group
                        };
                    });
                    if (this.userType === 'Petitioner') {
                        this.petitionerCompanyList = response[1];
                    }
                    else if (this.userType === 'Attorney') {
                        if (response[1] && response[1].petetionerList) {
                            this.companyListAssociatedWithAttorney = response[1].petetionerList;
                        }
                    }
                });
                break;
        }
    }
    getSubTaskType() {
        this.newTaskForm.patchValue({
            taskTypeCode: null,
        });
        if (this.newTaskForm.get('superTaskTypeCode').value) {
            this.createTaskService.getSubTasksType(this.newTaskForm.get('superTaskTypeCode').value)
                .subscribe((response) => {
                if (this.userType === 'Petitioner' || ['TN1', 'TN2'].includes(this.newTaskForm.get('visaType').value)) {
                    response = response.filter(ele => ele.code !== 'RFE');
                }
                this.subTaskType = response;
                if (!this.newTaskForm.get('isOutsideImagility').value) {
                    this.newTaskForm.patchValue({
                        taskTypeCode: 'PETITION'
                    });
                    this.onChangeSubTaskType();
                }
            });
        }
    }
    getSubTaskTypeList() {
        this.createTaskService.getSubTasksTypeListImmigrant(this.immCategoryCode, this.immClassificationCode).subscribe((response) => {
            this.subTaskType = response.subTaskTypeList;
            this.onChangeFilterDropDown();
        });
    }
    // checkOVisaValidation() {
    //     if (this.newTaskForm.get('visaType').value && this.OVisaTypeArray.includes(this.newTaskForm.get('visaType').value) && this.newTaskForm.get('extrAblDocEvdCatgCode') && this.newTaskForm.get('extrAblDocEvdCatgCode').value && this.newTaskForm.get('extrAblDocEvdCatgCode').value === 'OTHERDOCEVDN' && this.newTaskForm.get('applicableOptionCodes').value.length < 3) {
    //       return true;
    //     }
    //     return false;
    // }
    // saveTask() {
    //   let payload = this.newTaskForm.value;
    //   if (payload.taskTypeCode === 'PETITION' && payload.hasOwnProperty('questionAndResponseDTO')) {
    //     payload.questionAndResponseDTO.forEach((item) => {
    //       item.answer = item.answer ? 1 : 0;
    //       item.additionalInfo = item.additionalInfo !== null ? String(item.additionalInfo) : null;
    //     });
    //   }
    //   let taskType = '';
    //   if (this.isImmigrant) {
    //     taskType = 'IMMPET';
    //   } else { taskType = 'NONIMMPET'; }
    //   const visaType = payload.visaType;
    //   if (this.visaTypeArray.includes(payload.visaType)) {
    //     payload = {
    //       attorneyId: payload.attorneyId,
    //       authorizedSignatoryId: payload.authorizedSignatoryId,
    //       beneficiaryId: payload.beneficiaryId,
    //       companyId: payload.companyId,
    //       companyRelationCode: payload.companyRelationCode,
    //       foreignCompanyId: payload.foreignCompanyId,
    //       id: 0,
    //       immSpecialistId: payload.immSpecialistId,
    //       immigrantTypeCode: "VISA",
    //       isOutsideImagility: payload.isOutsideImagility ? 1 : 0,
    //       petitionTypeCode: payload.petitionType,
    //       preparerAttorneyId: payload.preparerAttorneyId,
    //       questionAndResponseDTO: payload.questionAndResponseDTO,
    //       serviceCenterId: payload.serviceCenterId,
    //       superTaskId: 0,
    //       superTaskTypeCode: payload.superTaskTypeCode,
    //       taskTypeCode: payload.taskTypeCode,
    //       visaTypeCode: payload.visaType,
    //       extrAblDocEvdCatgCode: payload.extrAblDocEvdCatgCode,
    //       fieldExtrAbltyCode: payload.fieldExtrAbltyCode,
    //       applicableOptionCodes: payload.applicableOptionCodes
    //     };
    //   }
    //   else {
    //     payload.isOutsideImagility = payload.isOutsideImagility ? 1 : 0;
    //   }
    //   const req = this.visaTypeArray.includes(visaType) || this.OVisaTypeArray.includes(visaType) ?
    //     this.createTaskService.saveVisa(payload, visaType) :
    //     this.createTaskService.saveTask(payload, this.immigrantType, taskType);
    //   req.subscribe((response: ImagilityBaseResponse) => {
    //     if (response) {
    //       let id;
    //       if (this.isImmigrant || this.visaTypeArray.includes(visaType) || this.OVisaTypeArray.includes(visaType)) {
    //         id = response.data;
    //       } else {
    //         id = response.data.superTaskId;
    //       }
    //       if (this.visaTypeArray.includes(visaType) || this.OVisaTypeArray.includes(visaType)) {
    //         this.createTaskService.getSuperTask(id)
    //           .pipe(
    //             take(1),
    //             mergeMap((superTaskOverView: TaskSummaryOverview) => {
    //               return this.createTaskService.createPetition(visaType, {
    //                 beneficiaryId: superTaskOverView.superTask.beneficiaryId,
    //                 companyId: superTaskOverView.superTask.companyId,
    //                 employeeId: sessionStorage.getItem('employeeId'),
    //                 taskId: superTaskOverView.subTaskList.find(x => x.taskTypeCode === 'PETITION').id
    //               });
    //             })
    //           ).subscribe((petitionResponse: any) => {
    //             this.toastr.success(response.message);
    //             this.newTaskForm.reset();
    //             this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/superTask/task-details`, id]);
    //           });
    //       } else {
    //         this.toastr.success(response.message);
    //         this.newTaskForm.reset();
    //         this.router.navigate([`${RolesRouteMap.userRoleRouteMapping[sessionStorage.getItem('userTypeRole')]}/dashboard/superTask/task-details`, id]);
    //       }
    //     }
    //   });
    // }
    setBeneCompany() {
        this.fetchDetailsForAttorney();
    }
    fetchDetailsForAttorney() {
        if (this.newTaskForm.get('beneficiaryId').value) {
            this.selectedBeneficiary = this.beneficiaryList
                .find(ele => ele.beneficiaryEmployeeId === this.newTaskForm.get('beneficiaryId').value);
        }
    }
    // for attorney to create petition flow
    onAttorneyCompanyChange() {
        this.newTaskForm.patchValue({
            beneficiaryId: null
        });
        if (this.newTaskForm.get('companyId').value && this.newTaskForm.get('visaType').value) {
            this.getBeneficiaryList(this.newTaskForm.get('companyId').value);
        }
    }
    fetchPetitionerBeneficiary() {
        this.newTaskForm.patchValue({
            beneficiaryId: null
        });
        if (this.newTaskForm.get('companyId').value) {
            this.getBeneficiaryList(this.newTaskForm.get('companyId').value);
        }
    }
    viewbeneficiaries() {
        this.viewBeneficiaryProfile.emit(this.newTaskForm.get('beneficiaryId').value);
    }
    viewcompany() {
        this.viewCompanyProfile.emit(this.newTaskForm.get('companyId').value);
    }
    onChangeFilterDropDown() {
        const task = {};
        task.visaType = this.newTaskForm.get('visaType').value;
        task.petitionType = this.newTaskForm.get('petitionType').value;
        task.taskTypeCode = this.newTaskForm.get('taskTypeCode').value;
        if (task.visaType && task.petitionType && task.taskTypeCode) {
            this.onTaskDetailsChange.emit();
        }
    }
    onChangeImmigrationClassification() {
        // let task: any = {};
        this.newTaskForm.patchValue({
            taskTypeCode: null,
        });
        this.immCategoryCode = this.newTaskForm.get('immCategoryCode').value;
        this.immClassificationCode = this.newTaskForm.get('immClassificationCode').value;
        this.selectedSubTask = '';
        this.selectedTaskType = '';
        this.getSubTaskTypeList();
    }
    handleSwitchChange() {
        this.petitionTaskComponent.getQuestionListForCreateTask();
        if (!this.newTaskForm.get('isOutsideImagility').value) {
            this.newTaskForm.patchValue({
                taskTypeCode: 'PETITION'
            });
            this.onChangeFilterDropDown();
        }
    }
    onChangeSubTaskType() {
        this.onChangeFilterDropDown();
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    getSelectedVisaType(val) {
        if (val === 'L1A' || val === 'L1B' || val === 'O1A' || val === 'O1B') {
            return true;
        }
        else
            false;
    }
    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
        this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
    }
}
CreateTaskLibraryComponent.ɵfac = function CreateTaskLibraryComponent_Factory(t) { return new (t || CreateTaskLibraryComponent)(i0.ɵɵdirectiveInject(i1$2.Router), i0.ɵɵdirectiveInject(i2.ReferenceLibraryService), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i5$1.Store), i0.ɵɵdirectiveInject(CreateTaskLibraryService)); };
CreateTaskLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CreateTaskLibraryComponent, selectors: [["create-task-library"]], viewQuery: function CreateTaskLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(PetitionTaskComponent, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.petitionTaskComponent = _t.first);
    } }, outputs: { viewBeneficiaryProfile: "viewBeneficiaryProfile", viewCompanyProfile: "viewCompanyProfile", onTaskDetailsChange: "onTaskDetailsChange" }, decls: 30, vars: 14, consts: [[1, "p-grid", "p-nogutter", "ml-4", "mr-5"], [1, "p-col-12", "p-mx-2"], [1, "p-text-bold", "p-ml-2", "p-my-2"], [1, "p-text-bold"], [3, "formGroup"], [1, "p-fluid", "p-formgrid", "p-grid", "px-3", "pt-2"], [1, "p-col-4"], ["for", "tasktype", 1, "create-task-label", "required"], ["inputId", "tasktype", "styleClass", "redBorder", "name", "superTaskTypeCode", "formControlName", "superTaskTypeCode", "placeholder", "Select Task Type", "optionLabel", "name", "optionValue", "code", 3, "options", "onChange"], ["class", "invalid-message", 4, "ngIf"], [4, "ngIf"], ["class", "p-col-3 mt-3", 4, "ngIf"], [1, "p-col-1", "p-mt-6", "p-pt-2", "view-btn-block"], [3, "click", 4, "ngIf"], [1, "p-grid", "dashed-line", "p-my-4", "mx-1"], [3, "ngIf"], [1, "invalid-message"], ["for", "visatype", 1, "create-task-label", "required"], ["inputId", "visatype", "formControlName", "visaType", "optionLabel", "name", "name", "visatype", "optionValue", "code", "placeholder", "Select Visa Type", 3, "options", "disabled", "onChange"], ["for", "immCategoryCode", 1, "create-task-label", "required"], ["inputId", "immCategoryCode", "formControlName", "immCategoryCode", "optionLabel", "name", "name", "immCategoryCode", "optionValue", "code", "placeholder", "Select Immigration Category", 3, "options", "disabled"], ["for", "petitiontype", 1, "create-task-label", "required"], ["inputId", "petitiontype", "formControlName", "petitionType", "name", "pettype", "optionLabel", "name", "optionValue", "code", "placeholder", "Select Petition Type", 3, "options", "disabled", "onChange"], ["for", "immClassificationCode", 1, "create-task-label", "required"], ["inputId", "immClassificationCode", "formControlName", "immClassificationCode", "name", "pettype", "optionLabel", "name", "optionValue", "code", "placeholder", "Select Immigration Classification", 3, "options", "disabled", "onChange"], [1, "p-col-3", "mt-3"], ["for", "companyname", 1, "create-task-label", "required"], ["inputId", "companyname", "formControlName", "companyId", "name", "companyId", "optionLabel", "companyName", "optionValue", "id", "placeholder", "Select a Company", 3, "options", "disabled", "onChange"], ["inputId", "companyname", "formControlName", "companyId", "name", "companyId", "optionLabel", "petitionerName", "optionValue", "petitionerId", "placeholder", "Select a Company", 3, "options", "disabled", "onChange"], [3, "click"], ["matTooltip", "View Company", 1, "material-icons"], ["for", "beneficiaryname", 1, "create-task-label", "required"], ["inputId", "beneficiaryname", "formControlName", "beneficiaryId", "name", "beneficiaryId", "optionLabel", "beneficiaryEmployeeFName", "optionValue", "beneficiaryEmployeeId", "placeholder", "Select a Beneficiary", 3, "options", "disabled", "onChange"], ["pTemplate", "item"], ["pTemplate", "selectedItem"], [1, "country-item", "country-item-value"], [1, "country-item"], ["matTooltip", "View Beneficiary", 1, "material-icons"], [1, "p-grid", "p-my-2", "px-3"], ["class", "p-col-4", "name", "question", 4, "ngIf"], [1, "p-col-1"], ["formControlName", "isOutsideImagility", 3, "ngClass", "disabled", "onChange", 4, "ngIf"], ["for", "tasktype", 1, "create-task-label", "mb-0", "required"], ["inputId", "tasktype", "formControlName", "taskTypeCode", "placeholder", "Select Task Type", "optionLabel", "name", "optionValue", "code", 3, "options", "onChange", 4, "ngIf"], ["class", "p-text-bold", 4, "ngIf"], [3, "ngSwitch"], ["class", "px-3", 4, "ngSwitchCase"], ["name", "question", 1, "p-col-4"], ["formControlName", "isOutsideImagility", 3, "ngClass", "disabled", "onChange"], ["inputId", "tasktype", "formControlName", "taskTypeCode", "placeholder", "Select Task Type", "optionLabel", "name", "optionValue", "code", 3, "options", "onChange"], [1, "px-3"], [3, "parentFormGroup"]], template: function CreateTaskLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "h5", 2);
        i0.ɵɵtext(3, "Create Task ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "p-card");
        i0.ɵɵelementStart(5, "h5", 3);
        i0.ɵɵtext(6, "Enter the Task Details ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "form", 4);
        i0.ɵɵelementStart(8, "div", 5);
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵelementStart(10, "label", 7);
        i0.ɵɵtext(11, "Task Type");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "p-dropdown", 8);
        i0.ɵɵlistener("onChange", function CreateTaskLibraryComponent_Template_p_dropdown_onChange_12_listener() { return ctx.getVisaType(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, CreateTaskLibraryComponent_span_13_Template, 2, 1, "span", 9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 6);
        i0.ɵɵtemplate(15, CreateTaskLibraryComponent_div_15_Template, 5, 3, "div", 10);
        i0.ɵɵtemplate(16, CreateTaskLibraryComponent_div_16_Template, 5, 3, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 6);
        i0.ɵɵtemplate(18, CreateTaskLibraryComponent_div_18_Template, 5, 3, "div", 10);
        i0.ɵɵtemplate(19, CreateTaskLibraryComponent_div_19_Template, 5, 3, "div", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(20, CreateTaskLibraryComponent_div_20_Template, 5, 3, "div", 11);
        i0.ɵɵtemplate(21, CreateTaskLibraryComponent_div_21_Template, 5, 3, "div", 11);
        i0.ɵɵelementStart(22, "div", 12);
        i0.ɵɵtemplate(23, CreateTaskLibraryComponent_a_23_Template, 3, 0, "a", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(24, CreateTaskLibraryComponent_div_24_Template, 7, 4, "div", 11);
        i0.ɵɵtemplate(25, CreateTaskLibraryComponent_div_25_Template, 7, 4, "div", 11);
        i0.ɵɵelementStart(26, "div", 12);
        i0.ɵɵtemplate(27, CreateTaskLibraryComponent_a_27_Template, 3, 0, "a", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(28, "div", 14);
        i0.ɵɵtemplate(29, CreateTaskLibraryComponent_ng_template_29_Template, 1, 1, "ng-template", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("formGroup", ctx.newTaskForm);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("options", ctx.taskTypeList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.newTaskForm.get("superTaskTypeCode").touched && (ctx.newTaskForm.get("superTaskTypeCode").errors == null ? null : ctx.newTaskForm.get("superTaskTypeCode").errors.required));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isImmigrant);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isImmigrant);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.isImmigrant);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isImmigrant);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.userType === "Petitioner");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.userType === "Attorney");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.newTaskForm.get("companyId").value);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.userType == "Petitioner");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.userType == "Attorney");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.newTaskForm.get("beneficiaryId").value);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.newTaskForm.get("petitionType").value || ctx.newTaskForm.get("immClassificationCode").value) && ctx.newTaskForm.get("beneficiaryId").value);
    } }, directives: [i7$1.Card, i1$1.ɵangular_packages_forms_forms_ba, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i5.Dropdown, i1$1.NgControlStatus, i1$1.FormControlName, i9.NgIf, i10$1.MatIcon, i6.PrimeTemplate, i9.NgSwitch, i9.NgSwitchCase, i9$1.InputSwitch, i9.NgClass, PetitionTaskComponent], styles: ["create-task-library.component.scss"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateTaskLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'create-task-library',
                templateUrl: 'create-task-library.component.html',
                styles: ['create-task-library.component.scss']
            }]
    }], function () { return [{ type: i1$2.Router }, { type: i2.ReferenceLibraryService }, { type: i3.ToastrService }, { type: i1$1.FormBuilder }, { type: i5$1.Store }, { type: CreateTaskLibraryService }]; }, { petitionTaskComponent: [{
            type: ViewChild,
            args: [PetitionTaskComponent]
        }], viewBeneficiaryProfile: [{
            type: Output
        }], viewCompanyProfile: [{
            type: Output
        }], onTaskDetailsChange: [{
            type: Output
        }] }); })();

class CreateTaskLibraryModule {
}
CreateTaskLibraryModule.ɵfac = function CreateTaskLibraryModule_Factory(t) { return new (t || CreateTaskLibraryModule)(); };
CreateTaskLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: CreateTaskLibraryModule });
CreateTaskLibraryModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CreateTaskLibraryModule, { declarations: [CreateTaskLibraryComponent,
        PetitionTaskComponent], imports: [PrimengLibraryModule,
        ReactiveFormsModule], exports: [CreateTaskLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CreateTaskLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    CreateTaskLibraryComponent,
                    PetitionTaskComponent
                ],
                imports: [
                    PrimengLibraryModule,
                    ReactiveFormsModule
                ],
                exports: [CreateTaskLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of create-task-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CreateTaskLibraryComponent, CreateTaskLibraryModule, CreateTaskLibraryService };
//# sourceMappingURL=create-task-library.js.map
